import { TRANSITION_IN } from "./AnimationConstants";
import {
  BLOCK,
  BLOCK_STATE,
  PAGE,
  TEXT,
  GROUP,
  BUTTON,
  SIMPLE,
  ICON,
  LINE,
  GRAPHIC,
  SVG,
  VIDEO,
  LOTTIE,
  GALLERY,
  SOCIAL,
  IFRAME,
} from "./DataTypes";
import { FORM_FIELD_ELEMENT_TYPES } from "./FormFieldConstants.mjs";
import {
  BACKGROUND_COLOR,
  BACKGROUND_FILL_TYPE,
  BACKGROUND_GRADIENT_COLOR_1,
  BACKGROUND_GRADIENT_COLOR_2,
  BACKGROUND_GRADIENT_ROTATION,
  BACKGROUND_IMAGE_OPACITY,
  BACKGROUND_IMAGE_POSITION,
  BACKGROUND_IMAGE_SCALE,
  BACKGROUND_IMAGE_SCROLL,
  BACKGROUND_MEDIA_IMAGE,
  BACKGROUND_MEDIA_TYPE,
  BACKGROUND_MEDIA_VIDEO,
  BACKGROUND_VIDEO_LOOP,
  BORDER_RADIUS,
  SHADOW_BLUR,
  SHADOW_COLOR,
  SHADOW_OFFSET_X,
  SHADOW_OFFSET_Y,
  SHADOW_STYLE,
  RECTANGLE_FILL_TYPE,
  RECTANGLE_BACKGROUND_COLOR,
  RECTANGLE_GRADIENT_COLOR_1,
  RECTANGLE_GRADIENT_COLOR_2,
  RECTANGLE_GRADIENT_ROTATION,
  GALLERY_AUTO_ADVANCE_TIME,
  GALLERY_COLUMNS,
  GALLERY_DOTS,
  GALLERY_DOTS_COLOR,
  GALLERY_DOTS_GAP,
  GALLERY_DOTS_LOCATION,
  GALLERY_DOTS_OFFSET,
  GALLERY_DOTS_SELECTED_COLOR,
  GALLERY_DOTS_SIZE,
  GALLERY_ENFORCE_ORDER,
  GALLERY_FULL_SCREEN_BACKGROUND_COLOR,
  GALLERY_FULL_SCREEN_CONTROL_COLOR,
  GALLERY_IMAGE_BORDER,
  GALLERY_IMAGE_BORDER_COLOR,
  GALLERY_IMAGE_BORDER_RADIUS,
  GALLERY_IMAGE_BORDER_WIDTH,
  GALLERY_IMAGE_PADDING,
  GALLERY_INACTIVE_IMAGES,
  GALLERY_INACTIVE_IMAGES_BLUR,
  GALLERY_INACTIVE_IMAGES_OPACITY,
  GALLERY_INACTIVE_IMAGES_PRELOAD,
  GALLERY_INACTIVE_IMAGES_SCALE,
  GALLERY_NO_LOOP,
  GALLERY_TRANSITION,
  GALLERY_TRANSITION_DURATION,
  GRAPHIC_STYLE_TYPE,
  GRAPHIC_STYLE_OFFSET_X,
  GRAPHIC_STYLE_OFFSET_Y,
  GRAPHIC_STYLE_HORIZONTAL_SHIFT,
  GRAPHIC_STYLE_SCALE_PERCENTAGE,
  OPACITY,
  BLUR,
  SOCIAL_GRID_ALIGNMENT,
  SOCIAL_GRID_AUTO_GAP,
  SOCIAL_GRID_GAP,
  SOCIAL_GRID_OVERFLOW,
  SOCIAL_GRID_ROWS,
  TEXT_COLOR,
  TEXT_FONT,
  TEXT_SIZE,
  TEXT_STYLE,
  TEXT_LINE_HEIGHT,
  TEXT_LETTER_SPACING,
  TEXT_LETTER_CASE,
  TEXT_ALIGNMENT,
  TEXT_OVERFLOW,
  TEXT_LINK_COLOR,
  TEXT_LINK_FORMAT,
  TEXT_LINK_HOVER_COLOR,
  TEXT_LINK_HOVER_FORMAT,
  TEXT_STYLES_LINK_COLOR,
  TEXT_STYLES_LINK_FORMAT,
  TEXT_STYLES_LINK_HOVER_COLOR,
  TEXT_STYLES_LINK_HOVER_FORMAT,
  BORDER_WIDTH,
  BORDER_COLOR,
  BORDER_STYLE,
  LINE_STYLE,
  LINE_COLOR,
  LINE_THICKNESS,
  LINE_DASH_SPACING,
  LINE_DASH_WIDTH,
  LINE_END_CAP,
  ICON_COLOR,
  ANIMATION_TYPE,
  ANIMATION_DURATION,
  ANIMATION_DELAY,
  ANIMATION_DIRECTION,
  IFRAME_SCALE,
  TRANSITION_TYPE_BOUNCE,
  TRANSITION_TYPE_FADE,
  TRANSITION_TYPE_FLIP,
  TRANSITION_TYPE_LIGHT_SPEED,
  TRANSITION_TYPE_NONE,
  TRANSITION_TYPE_ROLL,
  TRANSITION_TYPE_ROTATE,
  TRANSITION_TYPE_SLIDE,
  TRANSITION_TYPE_ZOOM,
  BUTTON_FILL_TYPE,
  BUTTON_BACKGROUND_COLOR,
  BUTTON_BORDER_COLOR,
  BUTTON_BORDER_WIDTH,
  BUTTON_PADDING,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
  BUTTON_BORDER,
  BUTTON_BORDER_STYLE,
  BUTTON_BORDER_RADIUS,
  BUTTON_TEXT_COLOR,
  BUTTON_TEXT_FONT,
  BUTTON_TEXT_SIZE,
  BUTTON_TEXT_LETTER_SPACING,
  BUTTON_TEXT_LETTER_CASE,
  BUTTON_TEXT_LINE_HEIGHT,
  BUTTON_GRADIENT_COLOR_1,
  BUTTON_GRADIENT_COLOR_2,
  BUTTON_GRADIENT_ROTATION,
  BUTTON_HOVER_BACKGROUND_COLOR,
  BUTTON_HOVER_GRADIENT_COLOR_1,
  BUTTON_HOVER_GRADIENT_COLOR_2,
  BUTTON_HOVER_GRADIENT_ROTATION,
  BUTTON_HOVER_BORDER_COLOR,
  BUTTON_HOVER_BORDER_WIDTH,
  BUTTON_HOVER_BORDER_RADIUS,
  BUTTON_HOVER_DURATION,
  BUTTON_HOVER_PADDING,
  BUTTON_HOVER_TEXT_COLOR,
  BUTTON_HOVER_TEXT_FONT,
  BUTTON_HOVER_TEXT_SIZE,
  BUTTON_HOVER_TEXT_LETTER_SPACING,
  BUTTON_HOVER_TEXT_LINE_HEIGHT,
  BUTTON_HOVER_TEXT_LETTER_CASE,
  BUTTON_HOVER_TEXT_ALIGNMENT,
  BUTTON_HOVER_TEXT_COLUMNS,
  BUTTON_HOVER_TEXT_COLUMNS_GAP,
  BUTTON_HOVER_TEXT_MARGIN_BOTTOM,
  BUTTON_HOVER_TEXT_OVERFLOW,
  HOVER_SHADOW_STYLE,
  HOVER_SHADOW_OFFSET_X,
  HOVER_SHADOW_OFFSET_Y,
  HOVER_SHADOW_COLOR,
  HOVER_SHADOW_BLUR,
  HOVER_OPACITY,
  HOVER_SHADOW_ROOT,
  BUTTON_HOVER_FILL_TYPE,
  HOVER_BLUR,
  BACKDROP_FILTER
} from "./MergeConstants";

export const BACKGROUND_VIDEO_PROPS = ["bgVideo", "bgLoop"];
export const BACKGROUND_IMAGE_PROPS = [
  "bgImage",
  "bgScroll",
  "bgOpacity",
  "bgScale",
  "bgPos",
];
export const BACKGROUND_GRADIENT_PROPS = [
  BACKGROUND_GRADIENT_COLOR_1,
  BACKGROUND_GRADIENT_COLOR_2,
  BACKGROUND_GRADIENT_ROTATION,
];

const PAGE_TRANSITION_IN = "defaultTrIn";
const PAGE_TRANSITION_OUT = "defaultTrOut";
const BLOCK_TRANSITION_IN = "trIn";
const BLOCK_TRANSITION_OUT = "trOut";
const STATE_TRANSITION_IN = "stateTrIn";
const STATE_TRANSITION_OUT = "stateTrOut";

const TRANSITION_MAPS = [
  PAGE_TRANSITION_IN,
  PAGE_TRANSITION_OUT,
  BLOCK_TRANSITION_IN,
  BLOCK_TRANSITION_OUT,
  STATE_TRANSITION_IN,
  STATE_TRANSITION_OUT,
].reduce((result, propName) => {
  result[`${propName}.${ANIMATION_TYPE}`] = [
    `${propName}.${ANIMATION_DELAY}`,
    `${propName}.${ANIMATION_DURATION}`,
    `${propName}.${ANIMATION_DIRECTION}`,
  ];
  return result;
}, {});

export const ALL_EFFECTS = [OPACITY, BLUR, BORDER_RADIUS, SHADOW_STYLE];
export const EFFECTS_NO_BR = [OPACITY, SHADOW_STYLE];
export const EFFECTS_NO_SHADOW = [OPACITY, BORDER_RADIUS];
export const ANIMATION_SYNC_PROPS = `${TRANSITION_IN}.${ANIMATION_TYPE}`;

/**
 * Used to designate sub-props that belong to a parent prop. Other files might refer to this as
 * parent/child props, with the parent being the key and list values being children.
 */
export const PROP_SUB_PROPS = {
  [BACKGROUND_FILL_TYPE]: [
    BACKGROUND_COLOR,
    BACKGROUND_GRADIENT_COLOR_1,
    BACKGROUND_GRADIENT_COLOR_2,
    BACKGROUND_GRADIENT_ROTATION,
  ],
  [BACKGROUND_MEDIA_TYPE]: [
    BACKGROUND_MEDIA_IMAGE,
    BACKGROUND_VIDEO_LOOP,
    BACKGROUND_IMAGE_OPACITY,
    BACKGROUND_IMAGE_POSITION,
    BACKGROUND_IMAGE_SCALE,
    BACKGROUND_IMAGE_SCROLL,
    BACKGROUND_MEDIA_VIDEO,
  ],
  [GALLERY_IMAGE_BORDER]: [
    GALLERY_IMAGE_BORDER_COLOR,
    GALLERY_IMAGE_BORDER_RADIUS,
    GALLERY_IMAGE_BORDER_WIDTH,
  ],
  [GALLERY_DOTS]: [
    GALLERY_DOTS_COLOR,
    GALLERY_DOTS_SELECTED_COLOR,
    GALLERY_DOTS_LOCATION,
    GALLERY_DOTS_SIZE,
    GALLERY_DOTS_GAP,
    GALLERY_DOTS_OFFSET,
  ],
  [GALLERY_INACTIVE_IMAGES]: [
    GALLERY_INACTIVE_IMAGES_BLUR,
    GALLERY_INACTIVE_IMAGES_OPACITY,
    GALLERY_INACTIVE_IMAGES_PRELOAD,
    GALLERY_INACTIVE_IMAGES_SCALE,
  ],
  [GRAPHIC_STYLE_TYPE]: [
    GRAPHIC_STYLE_OFFSET_X,
    GRAPHIC_STYLE_OFFSET_Y,
    GRAPHIC_STYLE_HORIZONTAL_SHIFT,
    GRAPHIC_STYLE_SCALE_PERCENTAGE,
  ],
  // todo: change this to more generic names
  [RECTANGLE_FILL_TYPE]: [
    RECTANGLE_BACKGROUND_COLOR,
    RECTANGLE_GRADIENT_COLOR_1,
    RECTANGLE_GRADIENT_COLOR_2,
    RECTANGLE_GRADIENT_ROTATION,
  ],
  [ANIMATION_TYPE]: [ANIMATION_DURATION, ANIMATION_DELAY, ANIMATION_DIRECTION],
  [SHADOW_STYLE]: [SHADOW_COLOR, SHADOW_OFFSET_X, SHADOW_OFFSET_Y, SHADOW_BLUR],
  ...TRANSITION_MAPS,
};

/**
 * Associated parent/child relationships that can be used by an entity. This lets processes know
 * to look for these relationships when either a parent or child is unset.
 * @deprecated
 */
export const MERGEABLE_PROP_MAP = {
  [BLOCK]: [BACKGROUND_FILL_TYPE, BACKGROUND_MEDIA_TYPE, ANIMATION_SYNC_PROPS],
  [BLOCK_STATE]: [
    BACKGROUND_FILL_TYPE,
    BACKGROUND_MEDIA_TYPE,
    ANIMATION_SYNC_PROPS,
  ],
  [BUTTON]: [RECTANGLE_FILL_TYPE, SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [PAGE]: [BACKGROUND_FILL_TYPE, ANIMATION_SYNC_PROPS],
  [TEXT]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [SIMPLE]: [
    RECTANGLE_FILL_TYPE,
    BORDER_STYLE,
    SHADOW_STYLE,
    ANIMATION_SYNC_PROPS,
  ],
  [LINE]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [GRAPHIC]: [GRAPHIC_STYLE_TYPE, SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [SVG]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [ICON]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [VIDEO]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [LOTTIE]: [SHADOW_STYLE, ANIMATION_SYNC_PROPS],
  [GALLERY]: [
    GALLERY_DOTS,
    GALLERY_IMAGE_BORDER,
    GALLERY_INACTIVE_IMAGES,
    SHADOW_STYLE,
    ANIMATION_SYNC_PROPS,
  ],
};

/**
 * List of props to give to an entity on creation, represented in that item's sync array.
 */
export const DEFAULT_MERGE_PROPS = {
  [BUTTON]: [ANIMATION_SYNC_PROPS],
  // Only the animation: form fields take every other sync from their theme style entry.
  ...Object.fromEntries(FORM_FIELD_ELEMENT_TYPES.map((type) => [type, [ANIMATION_SYNC_PROPS]])),
  [GALLERY]: [
    GRAPHIC_STYLE_TYPE,
    GALLERY_AUTO_ADVANCE_TIME,
    GALLERY_TRANSITION,
    GALLERY_TRANSITION_DURATION,
    GALLERY_COLUMNS,
    GALLERY_ENFORCE_ORDER,
    GALLERY_IMAGE_PADDING,
    GALLERY_IMAGE_BORDER,
    GALLERY_FULL_SCREEN_BACKGROUND_COLOR,
    GALLERY_FULL_SCREEN_CONTROL_COLOR,
    GALLERY_NO_LOOP,
    GALLERY_DOTS,
    GALLERY_INACTIVE_IMAGES,
    ...ALL_EFFECTS,
    ANIMATION_SYNC_PROPS,
  ],
  [GRAPHIC]: [GRAPHIC_STYLE_TYPE, ...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
  [IFRAME]: [IFRAME_SCALE, ...EFFECTS_NO_SHADOW, BLUR, ANIMATION_SYNC_PROPS],
  [ICON]: [ICON_COLOR, ...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
  [SIMPLE]: [
    BORDER_STYLE,
    RECTANGLE_FILL_TYPE,
    BACKDROP_FILTER,
    ...ALL_EFFECTS,
    ANIMATION_SYNC_PROPS,
  ],
  [GROUP]: [
    BORDER_STYLE,
    RECTANGLE_FILL_TYPE,
    ...ALL_EFFECTS,
    ANIMATION_SYNC_PROPS,
  ],
  [LINE]: [
    LINE_STYLE,
    LINE_COLOR,
    LINE_THICKNESS,
    LINE_DASH_SPACING,
    LINE_DASH_WIDTH,
    LINE_END_CAP,
    ...EFFECTS_NO_BR,
    BLUR,
    ANIMATION_SYNC_PROPS,
  ],
  [SOCIAL]: [
    SOCIAL_GRID_ALIGNMENT,
    SOCIAL_GRID_AUTO_GAP,
    SOCIAL_GRID_GAP,
    SOCIAL_GRID_OVERFLOW,
    SOCIAL_GRID_ROWS,
    ...EFFECTS_NO_SHADOW,
    ANIMATION_SYNC_PROPS,
  ],
  [SVG]: [...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
  [TEXT]: [TEXT_STYLE, TEXT_OVERFLOW, ...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
  [VIDEO]: [...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
  [LOTTIE]: [...ALL_EFFECTS, ANIMATION_SYNC_PROPS],
};

/**
 * TODO: rework this to be less ridiculous
 * Maps an entity's prop name to it's prop representation in design settings. Ideally, they match
 * moving forward.
 */
export const PROP_INHERITANCE_MAP = {
  [TEXT]: {
    [TEXT_COLOR]: TEXT_COLOR,
    [TEXT_FONT]: TEXT_FONT,
    [TEXT_SIZE]: TEXT_SIZE,
    [TEXT_LINE_HEIGHT]: TEXT_LINE_HEIGHT,
    [TEXT_LETTER_SPACING]: TEXT_LETTER_SPACING,
    [TEXT_LETTER_CASE]: TEXT_LETTER_CASE,
    [TEXT_ALIGNMENT]: TEXT_ALIGNMENT,
    [TEXT_STYLES_LINK_COLOR]: TEXT_LINK_COLOR,
    [TEXT_STYLES_LINK_FORMAT]: TEXT_LINK_FORMAT,
    [TEXT_STYLES_LINK_HOVER_COLOR]: TEXT_LINK_HOVER_COLOR,
    [TEXT_STYLES_LINK_HOVER_FORMAT]: TEXT_LINK_HOVER_FORMAT,
  },
  // maybe this isn't necessary?
  [BUTTON]: {
    [BUTTON_FILL_TYPE]: BUTTON_FILL_TYPE,
    [BUTTON_BACKGROUND_COLOR]: BUTTON_BACKGROUND_COLOR,
    [BUTTON_BORDER_COLOR]: BUTTON_BORDER_COLOR,
    [BUTTON_BORDER_WIDTH]: BUTTON_BORDER_WIDTH,
    [BUTTON_PADDING]: BUTTON_PADDING,
    [BUTTON_HEIGHT]: BUTTON_HEIGHT,
    [BUTTON_WIDTH]: BUTTON_WIDTH,
    [BUTTON_BORDER]: BUTTON_BORDER,
    // [BUTTON_RADIUS]: BUTTON_RADIUS,
    [BUTTON_BORDER_STYLE]: BUTTON_BORDER_STYLE,
    [BUTTON_BORDER_RADIUS]: BUTTON_BORDER_RADIUS,
    [BUTTON_TEXT_COLOR]: BUTTON_TEXT_COLOR,
    [BUTTON_TEXT_FONT]: BUTTON_TEXT_FONT,
    [BUTTON_TEXT_SIZE]: BUTTON_TEXT_SIZE,
    [BUTTON_TEXT_LETTER_SPACING]: BUTTON_TEXT_LETTER_SPACING,
    [BUTTON_TEXT_LETTER_CASE]: BUTTON_TEXT_LETTER_CASE,
    [BUTTON_TEXT_LINE_HEIGHT]: BUTTON_TEXT_LINE_HEIGHT,
    [BUTTON_GRADIENT_COLOR_1]: BUTTON_GRADIENT_COLOR_1,
    [BUTTON_GRADIENT_COLOR_2]: BUTTON_GRADIENT_COLOR_2,
    [BUTTON_GRADIENT_ROTATION]: BUTTON_GRADIENT_ROTATION,
    [BUTTON_HOVER_BACKGROUND_COLOR]: BUTTON_HOVER_BACKGROUND_COLOR,
    [BUTTON_HOVER_GRADIENT_COLOR_1]: BUTTON_HOVER_GRADIENT_COLOR_1,
    [BUTTON_HOVER_GRADIENT_COLOR_2]: BUTTON_HOVER_GRADIENT_COLOR_2,
    [BUTTON_HOVER_GRADIENT_ROTATION]: BUTTON_HOVER_GRADIENT_ROTATION,
    [BUTTON_HOVER_DURATION]: BUTTON_HOVER_DURATION,
    [BUTTON_HOVER_BORDER_COLOR]: BUTTON_HOVER_BORDER_COLOR,
    [BUTTON_HOVER_BORDER_WIDTH]: BUTTON_HOVER_BORDER_WIDTH,
    [BUTTON_HOVER_BORDER_RADIUS]: BUTTON_HOVER_BORDER_RADIUS,
    [BUTTON_HOVER_PADDING]: BUTTON_HOVER_PADDING,
    [BUTTON_HOVER_TEXT_COLOR]: BUTTON_HOVER_TEXT_COLOR,
    [BUTTON_HOVER_TEXT_FONT]: BUTTON_HOVER_TEXT_FONT,
    [BUTTON_HOVER_TEXT_SIZE]: BUTTON_HOVER_TEXT_SIZE,
    [BUTTON_HOVER_TEXT_LETTER_SPACING]: BUTTON_HOVER_TEXT_LETTER_SPACING,
    [BUTTON_HOVER_TEXT_LINE_HEIGHT]: BUTTON_HOVER_TEXT_LINE_HEIGHT,
    [BUTTON_HOVER_TEXT_LETTER_CASE]: BUTTON_HOVER_TEXT_LETTER_CASE,
    [BUTTON_HOVER_TEXT_ALIGNMENT]: BUTTON_HOVER_TEXT_ALIGNMENT,
    [BUTTON_HOVER_TEXT_COLUMNS]: BUTTON_HOVER_TEXT_COLUMNS,
    [BUTTON_HOVER_TEXT_COLUMNS_GAP]: BUTTON_HOVER_TEXT_COLUMNS_GAP,
    [BUTTON_HOVER_TEXT_MARGIN_BOTTOM]: BUTTON_HOVER_TEXT_MARGIN_BOTTOM,
    [BUTTON_HOVER_TEXT_OVERFLOW]: BUTTON_HOVER_TEXT_OVERFLOW,
    [SHADOW_STYLE]: SHADOW_STYLE,
    [SHADOW_COLOR]: SHADOW_COLOR,
    [SHADOW_OFFSET_X]: SHADOW_OFFSET_X,
    [SHADOW_OFFSET_Y]: SHADOW_OFFSET_Y,
    [SHADOW_BLUR]: SHADOW_BLUR,
    [HOVER_SHADOW_STYLE]: HOVER_SHADOW_STYLE,
    [HOVER_SHADOW_COLOR]: HOVER_SHADOW_COLOR,
    [HOVER_SHADOW_OFFSET_X]: HOVER_SHADOW_OFFSET_X,
    [HOVER_SHADOW_OFFSET_Y]: HOVER_SHADOW_OFFSET_Y,
    [HOVER_SHADOW_BLUR]: HOVER_SHADOW_BLUR,
    [OPACITY]: OPACITY,
    [BLUR]: BLUR,
    [HOVER_OPACITY]: HOVER_OPACITY,
    [HOVER_BLUR]: HOVER_BLUR,
  },
};

export const FILL_TYPE_COLOR = "color";
export const FILL_TYPE_GRADIENT = "gradient";
export const FILL_SELECTION_ADVANCED = "advanced";
const GRAPHIC_STYLE_SCALE = "zoom";
const GRAPHIC_STYLE_FILL = "cover";

const TRANSITION_MERGE_MAPS = [
  PAGE_TRANSITION_IN,
  PAGE_TRANSITION_OUT,
  BLOCK_TRANSITION_IN,
  BLOCK_TRANSITION_OUT,
  STATE_TRANSITION_IN,
  STATE_TRANSITION_OUT,
].reduce((result, propName) => {
  const transitionNoDirection = [ANIMATION_DURATION, ANIMATION_DELAY].map(
    (subPropName) => `${propName}.${subPropName}`
  );
  const transitionAll = [
    ...transitionNoDirection,
    `${propName}.${ANIMATION_DIRECTION}`,
  ];

  result[`${propName}.${ANIMATION_TYPE}`] = {
    [TRANSITION_TYPE_NONE]: [],
    [TRANSITION_TYPE_FADE]: transitionNoDirection,
    [TRANSITION_TYPE_SLIDE]: transitionAll,
    [TRANSITION_TYPE_BOUNCE]: transitionAll,
    [TRANSITION_TYPE_ROTATE]: transitionAll,
    [TRANSITION_TYPE_ZOOM]: transitionAll,
    [TRANSITION_TYPE_FLIP]: transitionAll,
    [TRANSITION_TYPE_ROLL]: transitionNoDirection,
    [TRANSITION_TYPE_LIGHT_SPEED]: transitionNoDirection,
  };
  return result;
}, {});

/**
 * Used to check if the base prop's sub props all match.
 * Keys within a set are prop *values* instead of prop names.
 * Default is used to point at another key
 * @deprecated
 */
export const SUB_PROP_SYNC_MAP = {
  [SHADOW_STYLE]: [SHADOW_BLUR, SHADOW_COLOR, SHADOW_OFFSET_X, SHADOW_OFFSET_Y],
  [RECTANGLE_FILL_TYPE]: {
    default: [RECTANGLE_BACKGROUND_COLOR],
    [FILL_TYPE_COLOR]: [RECTANGLE_BACKGROUND_COLOR],
    [FILL_TYPE_GRADIENT]: [
      RECTANGLE_GRADIENT_COLOR_1,
      RECTANGLE_GRADIENT_COLOR_2,
      RECTANGLE_GRADIENT_ROTATION,
    ],
  },
  [GRAPHIC_STYLE_TYPE]: {
    default: [GRAPHIC_STYLE_HORIZONTAL_SHIFT],
    [GRAPHIC_STYLE_SCALE]: [
      GRAPHIC_STYLE_OFFSET_X,
      GRAPHIC_STYLE_OFFSET_Y,
      GRAPHIC_STYLE_SCALE_PERCENTAGE,
    ],
    [GRAPHIC_STYLE_FILL]: [GRAPHIC_STYLE_HORIZONTAL_SHIFT],
  },
  [GALLERY_IMAGE_BORDER]: [
    GALLERY_IMAGE_BORDER_COLOR,
    GALLERY_IMAGE_BORDER_RADIUS,
    GALLERY_IMAGE_BORDER_WIDTH,
  ],
  [GALLERY_DOTS]: [
    GALLERY_DOTS_COLOR,
    GALLERY_DOTS_SELECTED_COLOR,
    GALLERY_DOTS_LOCATION,
    GALLERY_DOTS_SIZE,
    GALLERY_DOTS_GAP,
    GALLERY_DOTS_OFFSET,
  ],
  [GALLERY_INACTIVE_IMAGES]: [
    GALLERY_INACTIVE_IMAGES_BLUR,
    GALLERY_INACTIVE_IMAGES_OPACITY,
    GALLERY_INACTIVE_IMAGES_PRELOAD,
    GALLERY_INACTIVE_IMAGES_SCALE,
  ],
  ...TRANSITION_MERGE_MAPS,
};

export const ELEMENT_PARENT_PROP_OVERRIDES = {
  [BUTTON]: {
    [HOVER_SHADOW_STYLE]: [HOVER_SHADOW_ROOT],
    [BUTTON_HOVER_FILL_TYPE]: [
      BUTTON_HOVER_BACKGROUND_COLOR,
      BUTTON_HOVER_GRADIENT_COLOR_1,
      BUTTON_HOVER_GRADIENT_COLOR_2,
      BUTTON_HOVER_GRADIENT_ROTATION,
    ],
  },
};

export const EFFECTS = [OPACITY, BORDER_RADIUS, SHADOW_STYLE];
